/**
 * Переключатели блоков, которые временно убраны с экранов, но не из кода.
 * Поставить `true` — и блок возвращается на место, без правок разметки.
 */

/**
 * Бонусные баллы: пилюля с балансом на главной и в профиле, шит с историей
 * и списание баллов на оформлении.
 *
 * Логика расчёта остаётся на месте и ничего не ломает: тумблер списания
 * выключен, поэтому `scores` равен нулю, итог заказа считается как обычно,
 * а `payByCard` уходит нулём.
 */
export const SHOW_BONUS_POINTS = false

/**
 * Чат с поддержкой: строка «Обратная связь» в профиле, кнопка «Связаться
 * с поддержкой» на заказе, алерт о новом сообщении, точка непрочитанных
 * в нижнем меню и сами экраны переписки.
 *
 * Выключенным флагом закрыты и маршруты: по прямой ссылке или диплинку
 * `?startapp=chat_<id>` в переписку тоже не попасть.
 */
export const SHOW_SUPPORT_CHAT = false

/**
 * Обещанное время доставки: пилюля «~25 мин» в карточке статуса на главной,
 * в шите уведомления и на экране заказа.
 *
 * Расчёт остаётся на месте и ничего не ломает: `eta` по-прежнему считается
 * из `plannedDateTime`, просто его негде показать.
 */
export const SHOW_DELIVERY_TIME = false
